/**
全局变量
*/
export const apiProxy = {
  '/p2p/': 'https://test1.madailicai.com',
  '/backstreet/': 'http://test-console.ctcfin.com',
}
export const base = ''



// WEBPACK FOOTER //
// ./settings/global.js